import { render, staticRenderFns } from "./tableSent.vue?vue&type=template&id=56cddfaa&scoped=true"
import script from "./tableSent.vue?vue&type=script&lang=js"
export * from "./tableSent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cddfaa",
  null
  
)

export default component.exports